<template>
  <div class="ibox">

    <div class="mb-2 ibox-title pt-3">
      <h5><strong>Fornecedores associados a esta empresa</strong></h5>
    </div>

    <div class="ibox-content">

      <div class="row mt-4">
        <div class="col-md-6">
          <input v-model="query.generic" class="input form-control"
                 @keypress.enter="find()"
                 placeholder="Pesquisar por: Nome ou CNPJ">
          <search-icon @click="find()" class="icon icon-within"/>
        </div>
        <div class="col-md-6">
          <button
              class="btn btn-primary mr-2"
              @click="addOrRemoveManyProviders()"
          >
            Adicionar todas as empresas
          </button>
          <button class="btn btn-outline-red" @click="addOrRemoveManyProviders('remove')">
            Remover todas as empresas
          </button>
        </div>
      </div>

      <Table :company="company" :companies="companies" @checked="checkProvider($event)"/>

      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination
            v-model="params.page"
            :total-count="meta.totalCount"
            :total-pages="meta.totalPages"
            @pagination="pagination"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'
  import Table from '@/components/providers/container/card/TableProviderCompany'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'
  import GetAccount from '@/mixins/GetAccount.vue';

  export default {
    components: { Pagination, SearchIcon, Table },
    computed: {
      companies() {
        return this.getModels || []
      }
    },
    created() {
      this.query.type = 'provider'
      this.methods = ['company_ids']
      this.find()
    },
    data() {
      return {
        lastGenericSearch: '',
        nameModel: 'Company'
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      async addOrRemoveManyProviders(option = 'add') {
        if (!confirm('Tem certeza que deseja associar todos os fornecedores a esta empresa?'))
          return

        const method = option === 'add' ? 'add_ids' : 'remove_ids'
        const company = { id: this.company.id }

        if (typeof this.lastGenericSearch === 'string' && this.lastGenericSearch.length > 0) {
          const params = {
            fields: 'id',
            meta: false,
            q: { generic: this.lastGenericSearch }
          }

          const response = await this.axios.get(this.modelPath, { params })
          const ids = response.data.map(obj => obj.id)
          company.providers = { [method]: ids }
        } else {
          company.providers = { [method]: '*' }
        }

        await this.asyncTemplateSave(company, {
          after: () => this.find()
        })
      },
      checkProvider(provider) {
        const company = { id: this.company.id }

        if (provider.checked) {
          company.providers = { add_ids: provider.id }
        } else {
          company.providers = { remove_ids: provider.id }
        }
        this.save(company)
      },
      find() {
        this.asyncTemplateSelect({
          after: ({models}) => {
            this.updateProviders(models)
            this.lastGenericSearch = this.query.generic
          }
        })
      },
      pagination(page) {
        this.params.page = page
        this.asyncTemplateSelect({
          after: ({models}) => this.updateProviders(models),
          pagination: true
        })
      },
      save(company) {
        this.asyncTemplateSave(company)
      },
      updateProviders(providers) {
        providers.forEach(provider => {

          if (provider.companyIds.includes(this.company.id))
            this.$set(provider, 'checked', true)
          else
            this.$set(provider, 'checked', false)
        })
      }
    },
    mixins: [ModelMapper, GetAccount],
    name: 'CardProviders',
    props: {
      company: { required: true, type: Object },
    }
  }
</script>

<style scoped>

  p {
    color: var(--primary-text-color);
  }

  .table td {
    vertical-align: middle;
  }
</style>
